import { IContact } from 'clickNgo/entities/contact'

export const sortContacts = (a: IContact, b: IContact) => {
  if (a.workflowStatus && b.workflowStatus) {
    return new Date(b.modified).getTime() - new Date(a.modified).getTime()
  }

  if (a.workflowStatus) return -1
  if (b.workflowStatus) return 1

  return new Date(b.userCreatedDate).getTime() - new Date(a.userCreatedDate).getTime()
}
